import { useEffect, useRef, useState } from 'react'
import PhoneInput from 'react-phone-number-input'
import axios from 'axios'
import 'react-phone-number-input/style.css'
import './botForm.css'
import 'aos/dist/aos.css'


export default function BotForm(args) {

    const [botName, setBotName] = useState('')
    const [botNumber, setBotNumber] = useState()
    const botPolicyRef = useRef(null)
    const botNameRef = useRef(null)
    const botButtonRef = useRef(null)
    const botError = useRef('')
    const botResponce = useRef('')
    const botResponceFon = useRef('')

    function formSuccess() {
        botResponce.current.classList.toggle('formResponceFonActive')
        botResponceFon.current.classList.toggle('formResponceDivActive')
    }

    function pressEnter(e) {
        if (e.keyCode === 13) {
            if (e.target.id === 'name') {
                if (botName) {
                    document.getElementById('botNumber').focus()
                    botError.current.innerHTML = ''
                } else {
                    botNameRef.current.focus()
                    botError.current.innerHTML = 'Некорректное заполнение имени!'
                }
            } else {
                if (botNumber.length < 11) {
                    if (botPolicyRef.current.checked) {
                        submitForm()
                        botError.current.innerHTML = ''
                    } else {
                        document.getElementById('botNumber').focus()
                        botError.current.innerHTML = 'Вы не приняли политику конфиденциальности!'
                    }
                } else {
                    document.getElementById('botNumber').focus()
                    botError.current.innerHTML = 'Поле "Телефон" заполнен не корректно!'
                }
            }
        }
    }


    function submitForm() {

        if (botName) {
            if (botNumber) {
                if (botNumber.length >= 12 && botNumber[0] === '+' || botNumber.length >= 9 && botNumber[0] !== '+') {
                    if (botPolicyRef.current.checked) {
                        botButtonRef.current.disabled = true
                        let csrf = ''
                        let token = ''
                        if (document.cookie) {
                            csrf = document.cookie.split('; ')
                            for (let i in csrf) {
                                if (csrf[i].includes('csrftoken')) {
                                    token = csrf[i].replace("csrftoken=", '')
                                    break
                                }
                            }
                        }
                        botError.current.innerHTML = ''
                        axios.get('/api/bot_request', {
                            params: {
                                'name': botName,
                                'number': botNumber,
                                'theme': args.theme,
                            },

                        })
                            .then(response => {
                                botButtonRef.current.disabled = false
                                setBotName('')
                                setBotNumber('')
                                formSuccess()

                            })
                    } else {
                        document.getElementById('botNumber').focus()
                        botError.current.innerHTML = 'Вы не приняли политику конфиденциальности!'
                    }
                } else {
                    document.getElementById('botNumber').focus()
                    botError.current.innerHTML = 'Поле "Телефон" заполнен не корректно!'
                }
            } else {
                botNameRef.current.focus()
                botError.current.innerHTML = 'Некорректное заполнение имени!'
            }
        } else {
            botNameRef.current.focus()
            botError.current.innerHTML = 'Некорректное заполнение имени!'
        }



    }

    useEffect(() => {
        if (botNumber) {
            document.getElementById('botNumber').style.paddingLeft = '50px'
        }
    }, [botNumber])
    function numberFocus() {
        if (!botNumber) {
            setBotNumber('+7')
        }
    }
    function numberBlur() {
        if (!botNumber) {
            document.getElementById('botNumber').style.paddingLeft = '5%'
        }
    }
    return (
        <>
            {args.active ?
                <div className='formFonDiv'>
                    <div className="homeFormDiv botFormDiv">
                        <div onClick={() => args.setActive(false)} className='formFon'>
                        </div>
                        <div ref={botResponce} className='formResponceFon '></div>
                        <div ref={botResponceFon} className='formResponceDiv '>
                            <div className='formResponce'>
                                <p>Спасибо! Данные успешно отправлены</p>
                                <p>Вам позвонит первый освободившийся менеджер</p>
                                <p>ГРАФИК РАБОТЫ МЕНЕДЖЕРОВ:</p>
                                <span>пн. - пт. с 8:00 до 21:00 по МСК.</span>
                                <span>сб. - вс. с 11:00 до 21:00 по МСК.</span>
                                <button onClick={()=>{
                                        const x = formSuccess()
                                        const y = args.setActive(false)
                                }}>Понятно</button>
                            </div>
                        </div>
                        <div className="homeForm">
                            <div className='supportForm'>
                                <div className="botFormCloseDiv" onClick={() => args.setActive(false)}></div>
                                <h2>Оставить заявку на тему "{args.theme}"</h2>
                                <p>Заполните форму и мы с Вами свяжемся для консультации и подтверждения заказа.</p>
                                <div className='form'>
                                    <input ref={botNameRef} id='name' onKeyDown={pressEnter} onChange={event => setBotName(event.target.value)} value={botName} placeholder='Имя' className='nameInput' type="text" />

                                    {/* <div className='plusNumberInput formdiv'>
                                <span ref={plus}>+</span>
                                <input ref={numberRef} id='botNumber' onKeyDown={pressEnter} onFocus={numberFocus} onChange={event => setBotNumber(event.target.value)} value={number} placeholder='Телефон' className='numberInput' type="number" />
                            </div> */}
                                    <section>

                                        <PhoneInput
                                            id='botNumber'
                                            onKeyDown={pressEnter}
                                            onFocus={numberFocus}
                                            onBlur={numberBlur}
                                            placeholder="Телефон"
                                            value={botNumber}
                                            onChange={setBotNumber} />
                                    </section>
                                    <div className='formdiv'>
                                        <input ref={botPolicyRef} type="checkbox" name="polytic" id="polyticChekbox3" />
                                        <label htmlFor="polyticChekbox3">Я согласен с <a target='_blank' href="/static/files/privacy_policy.pdf"> политикой конфиденциальности</a></label>
                                    </div>
                                    <button ref={botButtonRef} onClick={submitForm}>Отправить</button>
                                </div>
                                <p ref={botError} className='errorText'></p>
                            </div>
                        </div>
                    </div>
                </div> : <></>}
        </>
    )
}